module.exports = __webpack_public_path__ + "static/week_week6_spot3-6f60d4e01c587efb678618fb5ed8fcf3.jpg";